import axios from "../lib/axios";
import { UsersResponse } from "../types/user";

export const userService = {
  getUsers: async (search?: string) => {
    const { data } = await axios.get<UsersResponse>("/users", {
      params: {
        $fields: "*",
        $sort: "_id:DESC",
        $limit: 50,
        ...(search ? { q: search } : {}),
      },
    });
    return data;
  },
};
